import { CellularBillingRow } from '../../../../shared/model/cellular-billing';
import { organizationPooling } from './organization-pooling-analysis';

/** Preview only. Saved totals are always reconstructed by Device Service. */
export function calculatePooling(rows: CellularBillingRow[], policies = []) {
  return organizationPooling(rows, policies);
}
